<!-- 
<template>
  <div class="KunboStock">
    <div class="stock">
      <div class="stock-name">
        <h1>{{ dealName }}</h1>
        <p>
          <countTo
            :startVal="0"
            :endVal="dealRMB"
            :duration="2000"
            :decimals="3"
            class="numb"
          ></countTo>
          <span>RMB</span>
        </p>
      </div>
      <div class="fenge"></div>
      <div class="deal-box">
        <ul class="deal">
          <li v-for="(item, index) in dealList" :key="index">
            <h1>{{ item.title }}</h1>
            <countTo
              :startVal="0"
              :endVal="item.numb"
              :duration="2000"
              :decimals="3"
            ></countTo>
          </li>
        </ul>
        <p>{{bjjzbjsj}}2021-08-02 11:00:00</p>
      </div>
    </div>
  </div>
</template>
 -->


<script>
import countTo from "vue-count-to";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: { countTo },
  data() {
    //这里存放数据
    return {
      dealName: "", //堃博生物 1245865
      dealRMB: 66.666,
      dealList: [
        {
          title: "", //最高
          numb: 88.888,
        },
        {
          title: "", //最低
          numb: 66.666,
        },
        {
          title: "", //成交量(手)
          numb: 77.777,
        },
        {
          title: "", //成交额(元)
          numb: 999999.9999,
        },
      ],
	  bjjzbjsj:"", //报价截至北京时间
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
	  //文字翻译
	  get_fanyi() {
	    const that = this;
	    $.ajax({
	      url: "/index.php?s=Home/Api/get_data",
	      type: "get",
	      datatype: "json",
	      data: {
	        act: "get_fanyi",
	      },
	      success: function (ret) {
	        var obj = JSON.parse(ret); //json数据转为数组
	        if (obj.code == "0000") {
	          that.kbsw = obj.data["kbsw"];
	          that.dealList[0].title = obj.data["zg"];
	          that.dealList[1].title = obj.data["zd"];
	          that.dealList[2].title = obj.data["cjl"];
	          that.dealList[3].title = obj.data["cje"];
			  that.bjjzbjsj = obj.data["bjjzbjsj"];
	        }
	      },
	      error: function (err) {
	        console.log("ajax错误");
	      },
	    });
	  },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
	  this.get_fanyi();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.KunboStock {
  width: 100%;
  .stock {
    width: $main-width;
    margin: 0 auto;
    height: 309px;
    background: #47aeea;
    border-radius: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 80px 0 60px;
    .stock-name {
      width: 24%;
      color: $text-color;
      text-align: left;
      h1 {
        font-size: 1.2rem;
      }
      p {
        margin-top: 26px;
        .numb {
          font-size: 3rem;
        }
      }
      span {
        display: inline-block;
        font-size: 1.5rem;
      }
    }
    .fenge {
      width: 3px;
      height: 245px;
      background: #f6f6f6;
    }
    .deal-box {
      width: 60%;
      .deal {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        color: $text-color;
        li {
          h1 {
            font-size: 1.1rem;
          }
          span {
            display: inline-block;
            margin-top: 30px;
            font-size: 1.5rem;
          }
        }
      }
      p {
        margin-top: 40px;
        font-size: 1rem;
        color: $text-color;
      }
    }
  }
}
@media screen and (max-width: $main-width) {
  .KunboStock {
    .stock {
      width: 100%;
      flex-wrap: wrap;
      padding: 0 10px;
      height: auto;
      .fenge {
        display: none;
      }
      .stock-name {
        width: 80%;
        margin: 20px auto 0;
      }
      .deal-box {
        width: 100%;
        margin: 0 auto 20px;
        .deal {
          flex-wrap: wrap;
          li {
            margin-top: 10px;
            span {
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/investor/KunboStock.vue